Additional information related to search bullet points that is accepted when posting a job ad.
